import { useEffect } from "react";
import { useSitzung } from "../plattform/sitzung";
import { nachDerAnmeldung } from "./abonnement";

/** Begleitet die Sitzung (einmal in der App): nach der Anmeldung mit Passkey die Zustimmung zu Benachrichtigungen. */
export function BenachrichtigungenBegleiten() {
  const { status, uid, art } = useSitzung();
  useEffect(() => {
    if (status === "angemeldet" && uid && art === "passkey") void nachDerAnmeldung(uid);
  }, [status, uid, art]);
  return null;
}
